const LoaderSpinner = () => {
    return (
        <div role="status">
            <img className='w-[100%] h-6' src="/loader.svg" alt="loader-img" />
        </div>
    )
}
export default LoaderSpinner;